import axios from "axios";
import { Cookies } from "react-cookie";
import { attachOdooDbParam, baseUrlApi } from "../../proxy";
import { showNotitfication } from "../../utils/Utils";

const cookies = new Cookies();

const CAxios = axios.create({
  baseURL: baseUrlApi,
  validateStatus: (status) => status < 400,
});

CAxios.interceptors.request.use((config) => {
  attachOdooDbParam(config);

  const { headers } = config;

  if (cookies.get("apiKey")) {
    headers["Authorization"] = "Bearer " + cookies.get("apiKey");
  }
  return config;
});

CAxios.interceptors.response.use(null, (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      cookies.remove("apiKey");
      window.location.replace("/");
    }
    if (error.response.status === 500) {
      showNotitfication("Error can you contact the administrator", "error");
    }
  }
  return Promise.reject(error);
});

export default CAxios;
